export function setNestedObjectValue(obj: any, path: string, value: string | boolean) {
    const pathParts = path.split('.');
    let current = obj;
    for (let i = 0; i < pathParts.length - 1; i++) {
        current = current[pathParts[i]];
    }
    current[pathParts[pathParts.length - 1]] = value;
}